import React from 'react'
import { complement, filter, isEmpty } from 'ramda'
import config from './pagesConfig'
import { Route } from 'react-router-dom'
import invariant from 'tiny-invariant'

import { EducationFeature } from 'education-tools'
import AuthenticationFork from '../components/AuthenticationFork'
import PageWrapper from '../containers/PageWrapper'
import NotFound from '../containers/NotFound'

function camelToKebab (input) {
  return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

function buildUrlPath (...paths) {
  const isNotEmpty = complement(isEmpty)
  const validPaths = filter(isNotEmpty, paths)
  return `/${camelToKebab(Array.prototype.join.call(validPaths, '/'))}`
}

const getPages = () => config.map(({ subpages, ...page }) => {
  invariant(page.responsibleTeam, `missing responsibleTeam for page ${page.path}`)

  if (!subpages) {
    return {
      ...page,
      filePath: page.name,
      urlPath: buildUrlPath(page.name),
      overrideTopBarConfig: Boolean(page.overrideTopBarConfig)
    }
  }

  return [
    subpages.map(subpage => ({
      ...page,
      ...subpage,
      filePath: [page.name, subpage.name].join('/'),
      urlPath: buildUrlPath(page.name, subpage.name, subpage.param),
      parentName: page.name,
      overrideTopBarConfig: subpage.overrideTopBarConfig
    })),
    {
      ...page,
      filePath: page.name,
      urlPath: buildUrlPath(page.name),
      overrideTopBarConfig: Boolean(page.overrideTopBarConfig)
    }
  ]
})
  .flat(2)
  .map(({ requireAuthentication, filePath, experimentationFeatureKey, ...pageConfig }) => {
    const Page = React.lazy(
      () => import(/* webpackChunkName: "page_[request]" */ './' + filePath)
    )

    return (
      <Route path={pageConfig.urlPath} key={pageConfig.urlPath} exact>
        <AuthenticationFork requireAuthentication={requireAuthentication}>
          <EducationFeature name={experimentationFeatureKey} orElse={<NotFound />}>
            <PageWrapper {...pageConfig}>
              <Page />
            </PageWrapper>
          </EducationFeature>
        </AuthenticationFork>
      </Route>
    )
  })

export { buildUrlPath }

export default getPages
